import type { MantineThemeOverride } from "@mantine/core";

const mantineTheme: MantineThemeOverride = {
  colors: {
    primary: [
      "#DADADA",
      "#DADADA",
      "#DADADA",
      "#DADADA",
      "#DADADA",
      "#DADADA",
      "#DADADA",
      "#DADADA",
      "#DADADA",
      "#DADADA",
      "#DADADA",
    ],
  },
  primaryColor: "primary",
  fontFamily: "Mona Sans Wide",
  autoContrast: true,
};

export default mantineTheme;
